var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4915 12.6462L18.2025 13.5292C17.7235 14.5218 17.069 15.4195 16.2705 16.1792C15.5562 16.8581 14.711 17.3841 13.7865 17.7252C12.7961 18.0876 11.7501 18.2744 10.6955 18.2772C9.56562 18.3384 8.43664 18.1416 7.39413 17.7017C6.35162 17.2618 5.42294 16.5903 4.67849 15.7382C3.28282 14.1522 2.51654 12.1098 2.52449 9.99718C2.51126 8.0579 3.15328 6.17097 4.34649 4.64218C5.0834 3.69882 6.03218 2.94232 7.11594 2.43396C8.19971 1.92561 9.38798 1.67971 10.5845 1.71618C11.8161 1.67509 13.0396 1.92923 14.153 2.45738C15.2663 2.98552 16.2372 3.77236 16.9845 4.75218C18.168 6.27981 18.774 8.17633 18.6955 10.1072H4.62449C4.59935 11.7725 5.23466 13.38 6.39149 14.5782C6.92958 15.1494 7.58123 15.6017 8.30456 15.906C9.02789 16.2103 9.80689 16.3599 10.5915 16.3452C11.3847 16.3373 12.17 16.1876 12.9105 15.9032C13.6124 15.6492 14.2658 15.2772 14.8425 14.8032C15.5035 14.1766 16.0602 13.4484 16.4915 12.6462ZM16.4915 8.39518C16.2846 7.4607 15.8903 6.57789 15.3325 5.80018C14.7887 5.12499 14.087 4.59404 13.2895 4.25418C12.4618 3.8587 11.5568 3.6514 10.6395 3.64718C9.17243 3.61777 7.74988 4.15172 6.66449 5.13918C5.74852 6.02949 5.09858 7.15728 4.78749 8.39618L16.4915 8.39518Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmall);
export default __webpack_public_path__ + "static/media/logo-small.39de16429f72ea8c7c475ffd21a722cf.svg";
export { ForwardRef as ReactComponent };